export * from './speedometer.module';
export * from './speedometer.component';
